export default __webpack_public_path__ + "static/media/how-to-ply.dedb86ca.png";